import React from "react";
import "../Css/Fields.css";
import { HiOutlineRefresh } from "react-icons/hi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { AiFillGitlab } from "react-icons/ai";
import { toast } from "react-toastify";
import { useOptionContext } from "../../contexts/OptionProvider";
import { useGame } from "../../hooks/hooks";
const showOrangeOptions = (dices, field) => {
	const [orangeDice] = dices.filter((dice) => dice.color === "orange");

	if (orangeDice?.location !== "unused") {
		return false;
	}
	if (field.value === 0) {
		return true;
	} else {
		return false;
	}
};
const showWhiteOptions = (dices, field) => {
	const [whiteDice] = dices.filter((dice) => dice.color === "white");

	if (whiteDice?.location !== "unused") {
		return false;
	}
	if (field.value === 0) {
		return true;
	} else {
		return false;
	}
};

function OrangeField(props) {
	const { optionActive } = useOptionContext();
	const { dices, handleFieldClick, state, rolled, joker } = useGame();
	return (
		<div className="orange-container">
			<TooltipComponent position="TopCenter" content="x2/x3 multipiziert die Augenzahl">
				<div className="start-field">
					<span className="start-field-arrow"></span>
				</div>
			</TooltipComponent>

			{props.fields.map((field, index) => {
				if (props.player === field.user_game_id) {
					return (
						<div className="field-group" key={`orange-field-${field.id}`}>
							<div
								className={`orange-field ${
									!props.myField
										? ""
										: (joker.orange &&
												field.value === 0 &&
												(index === 0 ||
													index === 11 ||
													index === 22 ||
													index === 33 ||
													props.fields[index - 1].value !== 0)) ||
										  (rolled &&
												state.user.id === state.lobby.current_player &&
												(index === 0 || index === 11 || index === 22 || index === 33
													? true
													: props.fields[index - 1].value !== 0) &&
												((showOrangeOptions(dices, field) && optionActive.orange) ||
													(showWhiteOptions(dices, field) && optionActive.white)))
										? "possible-choice"
										: ""
								}`}
								onClick={() => {
									!props.myField
										? console.log("not your Field")
										: joker.orange &&
										  field.value === 0 &&
										  (index === 0 ||
												index === 11 ||
												index === 22 ||
												index === 33 ||
												props.fields[index - 1].value !== 0)
										? handleFieldClick(field, "joker", "orange")
										: rolled &&
										  state.user.id === state.lobby.current_player &&
										  (index === 0 || index === 11 || index === 22 || index === 33
												? true
												: props.fields[index - 1].value !== 0) &&
										  showOrangeOptions(dices, field) &&
										  optionActive.orange
										? handleFieldClick(field, "orange", "orange")
										: state.user.id === state.lobby.current_player &&
										  rolled &&
										  (index === 0 || index === 11 || index === 22 || index === 33
												? true
												: props.fields[index - 1].value !== 0) &&
										  showWhiteOptions(dices, field) &&
										  optionActive.white
										? handleFieldClick(field, "white", "orange")
										: toast.success("It's not possible to use this field at the moment");
								}}>
								{field.value !== 0
									? field.value * field.multiplier
									: field.multiplier === 1
									? ""
									: `X${field.multiplier}`}
							</div>
							<div className={`orange-fields-item item-${field.item}`}>
								{field.item === null ? (
									""
								) : field.item === "fox" ? (
									<AiFillGitlab />
								) : field.item === "plus-one" ? (
									"+1"
								) : field.item === "roll-again" ? (
									<HiOutlineRefresh />
								) : (
									"?"
								)}
							</div>
						</div>
					);
				} else {
					return null;
				}
			})}
		</div>
	);
}

export default OrangeField;

